import { useContext } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { RequestAccessAPI } from '../index';
import { directoryType } from '../types';
import { DIRECTORY_TYPE } from '../../constants';
import { RequestAccessFormContext } from '../../contexts/request-access-form-context';

const useFetchBusinessAccounts = (directoryType: directoryType = DIRECTORY_TYPE.GOOGLE) => {
    const { accessId = '' } = useParams();
    const { directoryUserAccountId, directoryUserAccountSecret } =
        useContext(RequestAccessFormContext);

    const {
        data,
        isLoading,
        isFetching,
        isFetchingNextPage,
        isError,
        isFetchNextPageError,
        fetchNextPage,
        hasNextPage,
    } = useInfiniteQuery({
        queryKey: [
            'businessAccounts',
            directoryType,
            directoryUserAccountId,
            directoryUserAccountSecret,
            accessId,
        ],
        queryFn: ({ pageParam }) => {
            const params = {
                directoryUserAccountId: String(directoryUserAccountId),
                directoryUserAccountSecret,
                accessRequestFormAccessId: accessId,
                pageToken: String(pageParam),
            };

            return RequestAccessAPI.fetchBusinessAccounts(directoryType, params);
        },
        initialPageParam: '',
        getNextPageParam: (lastPage) => {
            return lastPage.nextPageToken;
        },
    });

    return {
        data,
        isLoading,
        isFetching,
        isFetchingNextPage,
        isError,
        isFetchNextPageError,
        fetchNextPage,
        hasNextPage,
    };
};

export { useFetchBusinessAccounts };
